export default class MatomoEvent {
    static send(eventId) {
        window._paq = window._paq || [];
        window._paq.push(['trackGoal', eventId]);
    }

    static init() {
        // Contact form submitted event
        window.addEventListener('contact:form:sent', () => {
            MatomoEvent.send(2);
        });

        // Newsletter subscription event
        window.addEventListener('newsletter:subscription', () => {
            MatomoEvent.send(3);
        });

        // Coffee CTA click event
        const coffeeCTA = document.querySelector('#coffee-cta');
        if (coffeeCTA) {
            coffeeCTA.addEventListener('click', () => MatomoEvent.send(1));
        }

        // Footer contact link click event
        const contactLink = document.querySelector('#footer-contact-link');
        if (contactLink) {
            contactLink.addEventListener('click', () => MatomoEvent.send(4));
        }

        // RSE report click event
        const rseReportLinks = document.querySelectorAll('[data-rse-report]')
        rseReportLinks.forEach((link) => {
            link.addEventListener('click', () => MatomoEvent.send(5));
        })
    }
}
